// jQuery bridge, compatible with PageFlow 1.x:
//   $('.pageflow').pageflow({...})         starts an editor on each element
//   $('.pageflow').pageflow('getHTML')     calls a method of the first editor
//   $('.pageflow').pageflow('instance')    returns the editor
// The 1.x events 'pandao:sync.pageflow' and 'pandao:restore.pageflow' still write / reload the field. The host
// sends the first one for its backups, while the user may be typing: the text being typed stays open.

export function installJQuery($, PageFlow) {
    if (!$ || !$.fn || $.fn.pageflow && $.fn.pageflow.isPageFlow2) return;
    $.fn.pageflow = function (options, ...args) {
        if (typeof options === 'string') {
            const editor = this[0] && this[0].pageflow;
            if (!editor) return undefined;
            if (options === 'instance') return editor;
            if (typeof editor[options] !== 'function') throw new Error(`PageFlow: unknown method ${options}`);
            const result = editor[options](...args);
            return result === editor ? this : result;
        }
        return this.each(function () {
            const editor = new PageFlow(this, options || {});
            const $el = $(this);
            // Same namespace as 1.x ("pageflow"), plus one of our own to unbind only ours.
            $el.off('.pf2')
                .on('pandao:sync.pageflow.pf2', () => editor.flush({ keepEditing: true }))
                .on('pandao:restore.pageflow.pf2', () => {
                    if (editor.input) editor.setHTML(editor.input.value, { history: false });
                });
        });
    };
    $.fn.pageflow.isPageFlow2 = true;
    $.fn.pageflow.PageFlow = PageFlow;
}
